import { Subject } from 'rxjs/Subject'
import { HttpHeaders } from '@angular/common/http'
import { Injectable, isDevMode, EventEmitter } from '@angular/core'

@Injectable()
export class AuthService {
  constructor() {}

  createHeaders() {
    let headers = new HttpHeaders()
    if (!isDevMode()) {
      headers = headers.append(
        'Cache-Control',
        'no-cache, no-store, must-revalidate'
      )
      headers = headers.append('Pragma', 'no-cache')
      headers = headers.append('Expires', '0')
    }
    headers = headers.append('Access-Control-Allow-Origin', '*')
    headers = headers.append('Access-Control-Allow-Headers', 'X-Requested-With')

    if (this.isAuthenitcated()) {
      headers = headers.append('Authorization', 'Bearer ' + this.getToken())
    }
    return headers
  }
  createRequestOptions() {
    const httpOptions = {
      headers: this.createHeaders()
    }
    return httpOptions
  }

  setToken(v) {
    localStorage.setItem('token', v)
  }

  getToken() {
    return localStorage.getItem('token')
  }

  isAuthenitcated() {
    return localStorage.getItem('token') && localStorage.getItem('token') !== ''
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/auth.service.ts